import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconDefinition } from '@fortawesome/fontawesome-common-types';

export interface IItemProps {
    title: string;
    icon: IconDefinition;
    color: string;
}

const Item: React.FC<IItemProps> = ({ title, icon, color }) => {
    return (
        <div className="flex items-baseline my-2">
            <span style={{ color }}>
                <FontAwesomeIcon icon={icon} />
            </span>
            <p className="ml-2 text-[14px] text-blueGray-600 max-w-[255px]">{title}</p>
        </div>
    );
};

export default Item;
